import exceededCapacity from 'components/utils/capacityExceeded';

// Entered volume above the container's total, then usable, capacity. Capacities are
// read from the form, where the operator can edit them. Full and empty containers
// use their capacity or zero, and a height measurement does not use the volume.
export default function volumeOverCapacity(values, { fillingStatus, liquidVolumeHidden = false }) {
  if (fillingStatus === 'full' || fillingStatus === 'empty' || liquidVolumeHidden) return null;
  if (values?.measurementType && values.measurementType !== 'liquidVolume') return null;
  const volume = values?.liquidVolume;
  const capacityKey = exceededCapacity(volume, {
    totalCapacity: values?.totalCapacity,
    usableCapacity: values?.usableCapacity,
  });
  return capacityKey ? { capacityKey, volume, capacity: values[capacityKey] } : null;
}
